var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 21",
    style: {
      enableBackground: "new 0 0 20 21"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.8,5.1c-0.4,0-0.8,0.3-0.8,0.8v0.9h-0.9c-0.4,0-0.8,0.3-0.8,0.8s0.3,0.8,0.8,0.8H13v0.9 c0,0.4,0.3,0.8,0.8,0.8s0.8-0.3,0.8-0.8V8.3h0.9c0.4,0,0.8-0.3,0.8-0.8s-0.3-0.8-0.8-0.8h-0.9V5.9C14.5,5.5,14.2,5.1,13.8,5.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8,2.2C14,1.5,11.9,2,10,3.8C8.1,2,6,1.5,4.2,2.2C2.3,3,1,5,1,7.8c0,1.3,0.5,2.5,1.2,3.7 c0.2,0.3,0.6,0.4,0.9,0.2s0.4-0.6,0.2-0.9c-0.6-1-1-2.1-1-3c0-2.4,1.1-4,2.4-4.5C6,2.9,7.8,3.2,9.5,5.1C9.7,5.2,9.8,5.3,10,5.3 c0.2,0,0.3-0.1,0.5-0.2c1.8-1.9,3.6-2.3,4.9-1.8c1.3,0.5,2.4,2,2.4,4.5c0,1.4-0.7,2.8-1.8,4.3c-1.1,1.4-2.5,2.7-3.7,3.7 C11,16.8,10.6,17,10,17s-1-0.3-2.1-1.2c-0.8-0.6-1.6-1.4-2.4-2.2c-0.2-0.2-0.6-0.3-0.9,0c-0.2,0.2-0.3,0.6,0,0.9 c0.8,0.9,1.7,1.7,2.5,2.3c1.1,0.9,1.8,1.5,2.9,1.5s1.9-0.6,2.9-1.5c1.2-1,2.7-2.4,3.9-3.9c1.2-1.5,2.1-3.3,2.1-5 C19,5,17.7,3,15.8,2.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.1549def0405b8101b2a3bf15d0b14a7c.svg";
export { ForwardRef as ReactComponent };